import { FIELD, OBJECT } from '@server/parser';
import { SWEEP_ELEMENTS } from '../helpers';

export const EXCLUDED_FROM_WHAT_DOES_IT_DO = [FIELD, OBJECT, ...SWEEP_ELEMENTS];

export const isWhatDoesItDoAllowed = (type: string) => {
  return !EXCLUDED_FROM_WHAT_DOES_IT_DO.includes(type);
};

export const isAiInputAllowed = (type: string) => {
  return !SWEEP_ELEMENTS.includes(type);
};
